import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useState, useEffect } from "react";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { composeEventHandlers } from "./auth-service-tools550.js";
import { ScrollAreaScrollbarVisible } from "./auth-service-tools548.js";
import { useDebouncedCallback } from "./auth-service-tools552.js";
const ScrollAreaScrollbarScroll = /*#__PURE__*/forwardRef((props, red) => {
  const {
    forceMount,
    ...scrollbarProps
  } = props;
  const context = useScrollAreaContext();
  const isHorizontal = props.orientation === "horizontal";
  const [state, setState] = useState("hidden");
  const debounceScrollEnd = useDebouncedCallback(() => setState("idle"), 100);
  useEffect(() => {
    if (state === "idle") {
      const hideTimer = window.setTimeout(() => setState("hidden"), context.scrollHideDelay);
      return () => window.clearTimeout(hideTimer);
    }

    return void 0;
  }, [state, context.scrollHideDelay]);
  useEffect(() => {
    const {
      viewport
    } = context;
    const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";

    if (viewport) {
      let prevScrollPos = viewport[scrollDirection];

      const handleScroll = () => {
        const scrollPos = viewport[scrollDirection];
        const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;

        if (hasScrollInDirectionChanged) {
          setState("scrolling");
          debounceScrollEnd();
        }

        prevScrollPos = scrollPos;
      };

      viewport.addEventListener("scroll", handleScroll);
      return () => viewport.removeEventListener("scroll", handleScroll);
    }

    return void 0;
  }, [context.viewport, isHorizontal, debounceScrollEnd]);

  if (forceMount || state !== "hidden") {
    return /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarVisible, {
      "data-state": state === "hidden" ? "hidden" : "visible",
      ...scrollbarProps,
      ref: red,
      onPointerEnter: composeEventHandlers(props.onPointerEnter, () => setState("interacting")),
      onPointerLeave: composeEventHandlers(props.onPointerLeave, () => setState("idle"))
    });
  }

  return null;
});
export { ScrollAreaScrollbarScroll };